<rav-modal modalId="change-password" modalTitle="Change Password">
  <rav-form
    data-cy="change-password"
    [formGroup]="changePasswordFormGroup"
    (formSubmit)="changePassword($event)"
    [fields]="[{ name: 'old_pass' }, { name: 'pass', hasPasswordMeter: true }, { name: 'pass_conf' }]"
    buttonText="Change Password"
    [hasCancel]="true"
    (cancel)="modal.close.next()"
  ></rav-form>
</rav-modal>
